import React from "react";
import { Tabs, Tab } from "@material-ui/core";

function a11yProps(index) {
    return {
        id: `scrollable-tab-${index}`,
        "aria-controls": `scrollable-tabpanel-${index}`,
    };
}

export default function TabsHeader({ tabIndex, setTabIndex, tabLabels }) {
    return (
        <Tabs
            value={tabIndex}
            onChange={(e, newValue) => setTabIndex(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable tabs"
            style={{ minHeight: 36 }}
        >
            {tabLabels.map((label, index) => (
                <Tab
                    key={index}
                    label={label}
                    {...a11yProps(index)}
                    style={{
                        minHeight: 36,
                        minWidth: "auto",
                        padding: "4px 12px",
                        fontSize: 13,
                        fontWeight: 500,
                    }}
                />
            ))}
        </Tabs>
    );
}
